import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faTimes } from '@fortawesome/free-solid-svg-icons';

// 创建一个自定义钩子来获取当前路径
const useCurrentPath = () => {
    const location = useLocation();
    return location.pathname;
};

const MessageCarousel = ({ carouselMessages = [], onClose }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    console.info("carouselMessages==", carouselMessages)

    // 使用自定义钩子获取当前路径
    const pathname = useCurrentPath();
    // 获取本地访问地址路径
    console.log("当前路径:", pathname);

    // 可以基于路径来决定是否显示弹窗
    if (pathname !== "/") {
        return null;
    }

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % totalMessages);
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + totalMessages) % totalMessages);
    };

    // 工具函数：将 \n 转换为 <br/>
    const formatContent = (content) => {
        return content.split('\n').map((line, index) => (
            <React.Fragment key={index}>
                {line}
                {index !== content.split('\n').length - 1 && <br />}
            </React.Fragment>
        ));
    };

    const totalMessages = carouselMessages.length;

    if (totalMessages === 0 || totalMessages === undefined) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-100 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl shadow-xl w-[75%] max-w-4xl min-w-md h-[55vh] md:h-[65vh] overflow-hidden relative transform origin-center transition-all duration-300">
                {/* 关闭按钮 - 扩大点击区域 */}
                <span className="absolute pb-2 top-2 right-2 flex justify-between items-center pl-0">
                    <button
                        className="w-10 h-10 text-gray-500 hover:text-gray-800  rounded-full flex items-center justify-center"
                        onClick={onClose}
                    >
                        <FontAwesomeIcon icon={faTimes} size="lg" />
                    </button>
                </span>

                {/* 固定标题区域 */}
                <div className="px-6 pt-11 pb-2 text-center border-b border-gray-200">
                    <div className="text-opacity-70 md:text-2xl font-semibold" >{carouselMessages[currentIndex].attributes.title}</div>
                </div>

                {/* 可滚动内容区域 */}
                <div className="h-[calc(55vh-10rem)] md:h-[calc(70vh-11rem)] px-4 pt-3 overflow-y-auto">
                    <div className="text-gray-600 text-sm  md:text-base leading-relaxed whitespace-pre-line">{formatContent(carouselMessages[currentIndex].attributes.content)}</div>
                </div>

                {/* 轮播控制 */}
                <div className="absolute bottom-0 left-0 right-0 flex justify-between items-center p-3">
                    <button
                        className="w-8 h-8 rounded-full bg-white shadow-md flex items-center justify-center hover:bg-gray-100 transition-colors"
                        onClick={handlePrev}
                        disabled={totalMessages <= 1}
                    >
                        <FontAwesomeIcon icon={faChevronLeft} size="lg" />
                    </button>

                    <div className="flex justify-center space-x-2">
                        {carouselMessages.map((_, index) => (
                            <span
                                key={index}
                                className={`w-2.5 h-2.5 rounded-full ${
                                    index === currentIndex ? 'bg-blue-500' : 'bg-gray-300'
                                } transition-all duration-300`}
                            ></span>
                        ))}
                    </div>

                    <button
                        className="w-8 h-8 rounded-full bg-white shadow-md flex items-center justify-center hover:bg-gray-100 transition-colors"
                        onClick={handleNext}
                        disabled={totalMessages <= 1}
                    >
                        <FontAwesomeIcon icon={faChevronRight} size="lg" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MessageCarousel;
